/**
 * @module router/patient-registry
 * @description UC-REG-315 — Padrón de pacientes registrados (Campana).
 *   - /patient-registry → consulta y descarga de la nómina (staff, no paciente).
 *   La vista se oculta sola si la API no expone `capabilities.patientRegistry`.
 */
const patientRegistryRoutes = [
  {
    path: "/patient-registry",
    name: "patient-registry",
    component: () =>
      import(
        /* webpackChunkName: "patient-registry" */ "../components/patient/PatientRegistry.vue"
      ),
  },
];

export default patientRegistryRoutes;
